import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LoginService } from './shared/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VariablesService } from 'src/app/globalService/variables.service';
import { ModuloService } from 'src/app/parametricas/shared/modulo.service';
import { InfoUserService } from 'src/app/info-user/shared/info-user.service';
import { CryptoService } from 'src/app/shared/crypto/crypto.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserInfo } from 'src/app/info-user/shared/user-info.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit {
  @ViewChild('recaptcha') recaptchaElement: ElementRef;

  loginForm: FormGroup;
  invalidLogin: boolean;
  url: string;
  captchaValidation: boolean;
  siteKey:string = "6LeDDyYqAAAAAAVbbXdaes7swa3SqgiqvIOee9lD";
  messageLoader:string = "Consultando Información";
  isLoader:boolean = false;

  constructor(
    private jwtHelper: JwtHelperService,
    private encryptService: CryptoService,
    private variableService: VariablesService,
    private loginService: LoginService,
    private _fb: FormBuilder,
    private router: Router,
    private _infoUser: InfoUserService,
    private toastr: ToastrService,
    private _moduleService: ModuloService) {
    this.inSession();
  }

  ngOnInit() {
    this.createForm();
  }

  ngAfterViewInit(){
    this.variableService.getVariables().then((result) => {
      this.siteKey = this.variableService.data.siteKeyCaptcha;
    });
    let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    if (isIEOrEdge) {
      $("#infoModal").modal('show');
    }

    this.addRecaptchaScript();
    this.inSession();
    
  }

  createForm() {
    this.loginForm = this._fb.group({
      userName: ["", Validators.required],
      password: ["", [Validators.required, Validators.minLength(8)]]
    });
  }

  resetForm() {
    this.loginForm.reset();
  }

  onSubmit() {
    this.runLogin();
  }

  inSession() {
    if (sessionStorage.getItem('jwt') != null) {
      this.router.navigate(["/"]);
    }
  }

  async runLogin() {
    if (this.captchaValidation === true) {
      this.isLoader = true;
      await this.loginService.postLogin(this.loginForm.value).then(
         async (r:any)  => {
          this._moduleService.modules = [];
          this.invalidLogin = false;
          if (r.error) {
            this.toastr.error(r.message);
            if (r.code == 903) {
              this.invalidLogin = true;
              this._moduleService.modules = [];
              this._infoUser.remove();
              sessionStorage.removeItem("jwt");
              sessionStorage.removeItem("userInfo");
              sessionStorage.clear();
              this.router.navigate(["forgotpass"]);
            }
            if(r.code == 905){
              let token = (<any>r).token;
              sessionStorage.setItem("jwt", token);
              await this.getDataUser();
              this.router.navigate(["/"]);
            }
          }else {
            let token = (<any>r).token;
            sessionStorage.setItem("jwt", token);
            await this.getDataUser();
            this.router.navigate(["/"]);
          }
          this.isLoader = false;
        },
        err => {
          this.invalidLogin = true;
          this.toastr.error("Un error a ocurrido mientras intentabamos iniciar su sesión, por favor contacte su administrador de soporte.", "Error");
          this.isLoader = false;
        }
      );
    } else {
      this.toastr.error("Validar captcha.");
    }
  }

  addRecaptchaScript() {
    let self = this;
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }

    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { self.renderReCaptcha(); return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': this.siteKey,
      'callback': (response) => {
        this.captchaValidation = true;
      }
    });
  }

  logOut() {
    this.invalidLogin = true;
    this._moduleService.modules = [];
    this._infoUser.remove();
    sessionStorage.removeItem("jwt");
    sessionStorage.removeItem("userInfo");
    sessionStorage.clear();

    this.router.navigate(["home-page"]);
  }

  async getDataUser() {
    if (sessionStorage.getItem('jwt') != null) {
      if (sessionStorage.getItem('userInfo') == null) {
        let stringJwt = sessionStorage.getItem('jwt');
        let tempTolen = "";
        let data  = {token:stringJwt};
        await this.loginService.dt(data).then((result:any) => {
          tempTolen = result.result;
        });
        let token = this.jwtHelper.decodeToken(tempTolen);
        let jwtUser = token.payLoad.user;
        let user = new UserInfo();
        user.idUser = jwtUser.IdSegUsuario;
        user.typeDoc = jwtUser.IdTipoDocumento;
        user.typePerson = jwtUser.IdSegTipoPersona;
        user.docNumber = jwtUser.NumeroDocumento;
        user.email = jwtUser.CorreoElectronico;
        user.name = jwtUser.Nombre;
        user.lastName = jwtUser.Apellido1;
        user.sourName = jwtUser.Apellido2;
        user.role = jwtUser.SegRolUsuario;
        user.modules = [-100];
        user.modulesWeCumplimineto = undefined;
        let item = this.encryptService.encrypt(JSON.stringify(user));
        sessionStorage.setItem('userInfo', item);
      }
    }
  }
}
